import { mergeAttributes, Node } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    sticker: {
      addSticker: ({ stickerId }: { stickerId: string }) => ReturnType;
    };
  }
}

export const StickerExtension = Node.create({
  name: 'sticker',
  selectable: false,

  addAttributes() {
    return {
      stickerId: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-stickerId'),
        renderHTML: (attributes) => {
          if (!attributes.stickerId) {
            return {};
          }

          return {
            'data-stickerId': attributes.stickerId,
          };
        },
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return [`span`, mergeAttributes({ 'data-type': this.name }, HTMLAttributes)];
  },

  parseHTML() {
    return [
      {
        tag: `span[data-type="sticker"]`,
      },
    ];
  },

  addCommands() {
    return {
      addSticker:
        ({ stickerId }) =>
        ({ commands, editor }) => {
          const stickers = editor.$node('stickers');
          if (stickers) {
            return commands.insertContentAt((stickers as any).resolvedPos.pos, {
              type: 'sticker',
              attrs: { stickerId },
            });
          }
          return false;
        },
    };
  },
});
